module.exports = __webpack_public_path__ + "static/media/login.c4b2c53a.png";